import axios from 'axios';
import React, { useEffect } from 'react';
import { useChannelIOApi } from 'react-channel-plugin';
import { alertRef } from '../../../../App';
import Modal from '../../../../Components/Modal/Modal';
import { Button } from '../../../../Components/StyledComponents';
import ModifyStoreInfo from './ModifyStoreInfo';

const StoreInfo = () => {
    const [ info, setInfo ] = React.useState({})//매장 정보
    const [ convList, setConvList ] = React.useState([])
    const [ isOrder, setIsOrder ] = React.useState(false);//오더 활성화 여부
    const [ isPickup, setIsPickup ] = React.useState(false);//포장 활성화 여부
    const [ isTable, setIsTable ] = React.useState(false);//테이블 활성화 여부
    const modalRef = React.useRef(null);

    const { showMessenger } = useChannelIOApi();

    useEffect(() => {
        getInfo();   
    },[])

    //오더 정보 Get
    const getInfo = () => {
        axios.get('/api/order/convenience')
        .then((data) => {
            setInfo(data.data)
            getIsOrder()
        })
    }

    //오더 활성화 여부 get
    const getIsOrder = () => {
        axios.get('/api/order/is_open')
        .then((data) => {
            if(data.data.useDelivery) setIsOrder(true)
            else setIsOrder(false)
            if(data.data.usePickup) setIsPickup(true)
            else setIsPickup(false)
            if(data.data.useTable) setIsTable(true)
            else setIsTable(false)
        })
    }

    //편의 정보 수정
    const patchConvInfo = (data) => {
        axios.patch('/api/order/convenience',{
            isParking : data.isParking,
            isValet : data.isValet,
            isWifi : data.isWifi,
            isRoom : data.isRoom,
            isDisabled : data.isDisabled,
            isPet : data.isPet,
            isBabySeat : data.isBabySeat,
            isGroup : data.isGroup,
            isSedentary : data.isSedentary,
        })
        .then((data) => {
            getInfo()
            modalRef.current.closeModal();
            alertRef.current.showAlert({ title : `편의정보가 수정 되었어요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }
    

    //편의 정보 handler
    const ConvInfo = () => {
        let infolist = '';
        let convlist = []
        let count = 0;

        if(info.OrderInfo.ConvenienceInfo){
            if( info.OrderInfo.ConvenienceInfo.isParking ){
                infolist += '주차 시설';
                count += 1;
            }
            if( info.OrderInfo.ConvenienceInfo.isValet ){
                if(count !== 0) infolist += ', '
                infolist += '발렛 주차';
                count += 1;
            }
            if( info.OrderInfo.ConvenienceInfo.isWifi ){
                if(count !== 0) infolist += ', '
                infolist += '와이파이';
                count += 1;
            }
            if( info.OrderInfo.ConvenienceInfo.isRoom ){
                if(count !== 0) infolist += ', '
                infolist += '룸';
                count += 1;
            }
            if( info.OrderInfo.ConvenienceInfo.isDisabled ){
                if(count !== 0) infolist += ', '
                infolist += '장애인 편의시설';
                count += 1;
            }

            if( info.OrderInfo.ConvenienceInfo.isPet ){
                if(count !== 0) infolist += ', '
                infolist += '반려동물 동반';
                count += 1;
            }
            if( info.OrderInfo.ConvenienceInfo.isBabySeat ){
                if(count !== 0) infolist += ', '
                infolist += '유아용 좌석';
                count += 1;
            }
            if( info.OrderInfo.ConvenienceInfo.isGroup ){
                if(count !== 0) infolist += ', '
                infolist += '단체석';
                count += 1;
            }
            if( info.OrderInfo.ConvenienceInfo.isSedentary ){
                if(count !== 0) infolist += ', '
                infolist += '좌식';
                count += 1;
            }

            return infolist;
        }else {
            return ''
        }
    }

    return (
        <div className='store-info'>
            {
                Object.keys(info).length > 0 && 
                <>
                    <div className='info-box'>
                        <div className='row between'>
                            <div>
                                <p className='info-box-title'>오더 서비스</p>
                                <p className='info-sub-title'>현재 활성화된 오더 서비스를 확인해보세요.</p>
                            </div>
                            <Button variant="sub" className='edit-btn' style={{ width : 118 }} onClick={showMessenger}>
                                수정 요청하기
                            </Button>
                        </div>

                        <div className='header-divider' ></div>

                        <div className='row'>
                            <p className='info-title'>배달</p>
                            <p className='info-text'>{isOrder ? '활성화' : '비활성화'}</p>
                        </div>
                        <div className='divider' ></div>

                        <div className='row'>
                            <p className='info-title'>포장</p>
                            <p className='info-text'>{isPickup ? '활성화' : '비활성화'}</p>
                        </div>
                        <div className='divider' ></div>

                        <div className='row'>
                            <p className='info-title'>테이블</p>
                            <p className='info-text'>{isTable ? '활성화' : '비활성화'}</p>
                        </div>
                    </div>

                    <div className='info-box'>
                        <p className='info-box-title'>기본정보</p>
                        <p className='info-sub-title'>우리 매장에 대한 기본 정보를 입력하세요.</p>

                        <div className='header-divider' ></div>

                        <div className='row'>
                            <p className='info-title'>매장 이름</p>
                            <p className='info-text'>{info.Name}</p>
                        </div>
                        <div className='divider' ></div>
                        
                        <div className='row'>
                            <p className='info-title'>매장 번호</p>
                            <div>
                                <p className='info-text'>매장 번호 : {info.Tel}</p>
                                <p className='info-text'>사장님 번호 : {info.ManagerTel}</p>
                            </div>
                        </div>
                        <div className='divider' ></div>

                        <div className='row'>
                            <p className='info-title'>매장 주소</p>
                            <div>
                                <p className='info-text'>도로명 주소 : {info.RoadAddress}, {info.DetailAddress}</p>
                                <p className='info-text'>매장 주소 : {info.Address}, {info.DetailAddress}</p>
                            </div>
                        </div>
                        <div className='divider' ></div>

                        <div className='row'>
                            <p className='info-title'>매장 업종</p>
                            <p className='info-text'>{info.Category}</p>
                        </div>
                    </div>

                    <div className='info-box'>
                        <div className='row between'>
                            <div>
                                <p className='info-box-title'>편의정보</p>
                                <p className='info-sub-title'>우리 매장에 대한 기본 정보를 입력해요.</p>
                            </div>
                            <Button variant="sub" className='edit-btn' onClick={() => modalRef.current.openModal()}>
                                수정하기
                            </Button>
                        </div>

                        <div className='header-divider' ></div>

                        <div className='row'>
                            <p className='info-title'>주차</p>
                            <p className='info-text'>{ ( typeof info.OrderInfo !== 'undefined' && Object.keys(info.OrderInfo).length > 0 && info.OrderInfo.ConvenienceInfo.isParking) ? '주차가능' : '주차불가능'}</p>
                        </div>
                        <div className='divider' ></div>
                        
                        <div className='row'>
                            <p className='info-title'>발렛파킹</p>
                            <p className='info-text'>{ ( typeof info.OrderInfo !== 'undefined' && Object.keys(info.OrderInfo).length > 0 &&  info.OrderInfo.ConvenienceInfo.isValet) ? '발렛가능' : '발렛불가능' }</p>
                        </div>
                        <div className='divider' ></div>

                        <div className='row'>
                            <p className='info-title'>편의시설</p>
                            <p className='info-text'>{ typeof info.OrderInfo !== 'undefined' && Object.keys(info.OrderInfo).length > 0 ? ConvInfo() : '편의시설 없음'}</p>
                        </div>
                    </div>
                </>
            }

            <Modal ref={modalRef} contentContainer={{ width : 472 }} isHeader title={'편의정보 수정하기'}>
                <ModifyStoreInfo patch={patchConvInfo} info={info}/>
            </Modal>
        </div>
    )
}

export default StoreInfo;